<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-2 lg:tw-pb-4">
               <h2>Peça já o seu<br><span>Aparelho Grátis</span></h2>
            </div>
            <fieldset class="tw-px-5 tw-pb-5">
                <validation-provider class="tw-w-full tw-w-block" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text"
                            placeholder=" "
                            v-model="fullName"
                            class="bf"
                        >
                        <label class="bf">
                            Nome e Apelido
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|email" v-slot="{ classes }" name="email">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="email"
                            placeholder=" "
                            v-model.lazy="email"
                            class="bf"
                        >
                        <label class="bf">
                            Email
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" rules="required|phone:pt" v-slot="{ classes }" name="phone">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel"
                            placeholder=" "
                            v-model="phone"
                            v-mask="'999999999'"
                            class="bf"
                        >
                        <label class="bf">
                            Telefone
                        </label>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark bf"></span>
                                <span>Autorizo a Minisom a utilizar os meus dados para ser contactado segundo a sua <a href="https://www.minisom.pt/politica-de-privacidade" target="_blank"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: true } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="marketing">
                                <span class="checkmark bf"></span>
                                <span>Desejo receber informação e ofertas – marketing direto - da Minisom (Amplifon Portugal, S.A.)</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>
                <div class="tw-text-center tw-mt-4 tw-w-full">
                    <button type="submit" class="btn-cta bf">
                        PEDIR OFERTA
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponentBlackfriday',
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            page: 'minisom.aparelho.pt/blackfriday',
            marketing: false,

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                page: this.page,
                marketing: this.marketing,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

</style>
